import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=82b0cc04&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"
import style0 from "./Content.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Content.vue?vue&type=style&index=1&id=82b0cc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b0cc04",
  null
  
)

export default component.exports